import React from 'react'
import styles from './Hint.scss'
import { Icon, Button, Flex, FlexColumn } from 'components'

const Hint = (props) => {
	let styleName = "success"
	if(props.type === "error") {
		styleName = "error"
	}

	let classNames = styles.hint;

	if(props.noPrint) {
		classNames = classNames + ' ' + styles.noPrint;
	}


  	return (
		<div className={styles[styleName] + ' ' + classNames}>
			<Flex break="m">
				<FlexColumn col="4*4 - 264px">
					<Flex>
						<FlexColumn col="10*1">
				            <div className={styles.icon}>
				            	<Icon type="image" content={props.type} width="25px" />
				            </div>
				        </FlexColumn>
			            <FlexColumn col="10*9">
			            	<div className={styles.text}>{props.text}</div>
			            </FlexColumn>
			        </Flex>
			    </FlexColumn>
				<FlexColumn width="264px" align="right">
					<Button width="264px" value={props.buttonText} onClick={props.buttonClicked} theme="dark" />
				</FlexColumn>
			</Flex>
		</div>
	)
}
export default Hint



// WEBPACK FOOTER //
// ./src/components/atoms/Hint/index.js